import ajax, {cancelToken} from './Ajax';

export const getData = (params) => {
  const {cancelToken, cancel} = getCancelConfig();
  return {
    request: ajax.get('/unifierProjectContract',{params, cancelToken}),
    cancel
  }
};

export const getSearchBoxOptions = (data) => {
  const {cancelToken, cancel} = getCancelConfig();
  return {
    request: ajax.post('projectContractFilter', data, {cancelToken}),
    cancel
  }
};

function getCancelConfig(){
  const source = cancelToken.source();
  return {
    cancelToken: source.token,
    cancel: source.cancel
  }
}


// WEBPACK FOOTER //
// ./src/utils/api.js